@if (featureSet) {
  <div class="container-fluid">
    <div class="row justify-content-start">
      <div class="col-md-8 col-xs-12">
        <div class="mt-3" name="timeSpan" aria-label="Time Span">
          <mat-button-toggle class="lw-toggle-btn" [ngClass]="this.timespan === 'weekly' ? 'active' : ''" value="weekly"
            (click)="changeTimeSpan('weekly')">Weekly
          </mat-button-toggle>
          <mat-button-toggle class="lw-toggle-btn" [ngClass]="this.timespan === 'monthly' ? 'active' : ''" value="monthly"
            (click)="changeTimeSpan('monthly')">Monthly
          </mat-button-toggle>
          <mat-button-toggle class="lw-toggle-btn" [ngClass]="this.timespan === 'custom' ? 'active' : ''" value="custom"
            (click)="changeTimeSpan('custom')">Custom
          </mat-button-toggle>
        </div>
        <div class="left-graph-container">
          <div [ngClass]="[heightStyleMain]">
            <table mat-table [dataSource]="data" class="wire-free-table">
              <ng-container matColumnDef="Timestamp">
                <th mat-header-cell *matHeaderCellDef>Timestamp</th>
                <td mat-cell *matCellDef="let element"> {{getDate(element.timestamp)}} </td>
              </ng-container>
              <ng-container matColumnDef="Value">
                <th mat-header-cell *matHeaderCellDef>Value</th>
                <td mat-cell
                *matCellDef="let element"> {{decodeUiButtonValue(element.value, 'uiButtonPair').pressType}} </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
            <mat-paginator class="wire-free-paginator" #paginator [pageSize]="10" [pageSizeOptions]="[5, 10, 20]"
              [showFirstLastButtons]="true">
            </mat-paginator>
          </div>
        </div>
      </div>
      <div class="pl-md-0 col-md-4 pt-md-4 pt-3 col-xs-12 mb-2">
        <div class="info-container py-2 text-center mb-2">
          <div class="icon">
            <i class="{{ icons.getIcon(featureSet.productCode) }}" [style.margin-left]="this.icon_margin"></i>
          </div>
          <div class="productcode-box">
            {{displayProductCode(featureSet.productCode)}}
          </div>
        </div>
      </div>
    </div>
    <div class="below-graph">
      <button class="lds-btn" (click)="onExportClick()">Export Data</button>
    </div>
  </div>
}

